export default {
  departmentList: null,
  departmentAll: null,
  authorityList: null,
  roleList: {
    status: 0,
    data: [],
  },
};
